import defineComponent from 'flight';
import MinimalRouter from 'static/script/utils/minimal-router';
import memberInfo from 'static/script/app/data/member-info';

function SaveSearchUI() {
    this.defaultAttrs({
        saveSearchForm: '[data-save-search-form]',
        saveSearchSubmit: '[data-save-search-submit]',
        showModalFeedbackContentSelector: '[data-modal-tooltip-savesearch-content]',
        savedSearchIdName: 'saved-search-id',
        modalName: 'savesearch',
        buttonIsToggledClass: 'toggle--on',
        initData: null
    });

    this._actionButtonClicked = function (evt) {
        if (evt) {
            evt.preventDefault();
        }

        if (!memberInfo.isLoggedIn) {
            let destination = location.protocol + '//' + location.host + location.pathname + location.search + '#' + 'modal=' + this.attr.modalName;
            this.trigger(document, 'ui:login:show', { destination: encodeURIComponent(destination) });
            return;
        }

        let button = this.select('saveSearchSubmit');

        if (button.data(this.attr.savedSearchIdName) > 0) {
            this._removeSavedSearch(button.data(this.attr.savedSearchIdName));
        } else {
            this._saveSearch();
        }

        this._disableSubmitButton();
    };

    this._removeSavedSearch = function (searchId) {
        let payload = {
            ids: [searchId]
        };

        this.trigger(document, 'ui:saved-searches:on-remove', payload);
        this.trigger(document, 'analytics:track-event', {
            category: 'Item result list',
            action: 'Remove',
            label: 'Save search | ' + this._getNrOfHits()
        });
    };

    this._saveSearch = function () {
        let payload = {
            data: this.select('saveSearchForm').serialize()
        };

        this.trigger(document, 'ui:saved-searches:on-adding', payload);
        this.trigger(document, 'analytics:track-event', {
            category: 'Item result list',
            action: 'Add',
            label: 'Save search | ' + this._getNrOfHits()
        });
    };

    this._getNrOfHits = function () {
        if (this.attr.initData &&
            this.attr.initData.pageSpecificData) {
            return this.attr.initData.pageSpecificData.itemResultTotalItems;
        }
    };

    this._searchSaved = function (evt, responseData) {
        let button = this.select('saveSearchSubmit');

        if (responseData.message === 'OK') {
            button.data(this.attr.savedSearchIdName, responseData.id);
            button.addClass(this.attr.buttonIsToggledClass);
            if (button.is(':visible')) {
                this._showModalTooltipFeedback(responseData.id);
            }
        }

        this._enableSubmitButton();
    };

    this._searchRemoved = function (evt, responseData) {
        let button = this.select('saveSearchSubmit');

        if (responseData.ids && responseData.ids.length > 0) {
            button.removeData(this.attr.savedSearchIdName);
            button.removeClass(this.attr.buttonIsToggledClass);
        }

        this._enableSubmitButton();
    };

    this._showModalTooltipFeedback = function (searchId) {
        let submitButton = this.select('saveSearchSubmit'),
            modalTooltipHtml = _.template(this.select('showModalFeedbackContentSelector').html()),
            opts = {
                content: modalTooltipHtml({id: searchId}),
                element: submitButton,
                cssClass: 'modal-tooltip'
            };

        this.trigger('ui:save-search:on-modal-tooltip-open', opts);
    };

    this._disableSubmitButton = function () {
        let button = this.select('saveSearchSubmit');
        button.addClass('disabled');
        button.prop('disabled', true);
    };

    this._enableSubmitButton = function () {
        let button = this.select('saveSearchSubmit');
        button.removeClass('disabled');
        button.prop('disabled', false);
    };

    this._userReturnedAfterLogin = function () {
        history.replaceState({}, window.title, location.pathname + location.search); // Remove hash
        this._actionButtonClicked();
    };

    this.after('initialize', function () {
        this.on('submit', {
            saveSearchForm: this._actionButtonClicked
        });

        this.on(document, 'data:saved-searches:after-added', this._searchSaved);
        this.on(document, 'data:saved-searches:after-removed', this._searchRemoved);
        this.defineHashRoute('modal=savesearch', this._userReturnedAfterLogin);
    });
}

module.exports = defineComponent.component(SaveSearchUI, MinimalRouter);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/save-search-ui.js